import React, { Component } from "react";
import { Timeline } from "antd";
import moment from 'moment';
import { StrokeIcon } from "../Theme/Icon";

/**
 *
 */
class PostedSchedulesList extends Component {

    previousNineStyle = () => {
        if (this.props.listPreviousPostingsArrays.previous7Days && this.props.listPreviousPostingsArrays.previous7Days.length > 0) {
            return { marginTop: -45, marginBottom: -15 }
        }
        return { marginBottom: -15 }
    }

    render() {
        if (
            !this.props.listPreviousPostingsArrays
            || (
                !this.props.listPreviousPostingsArrays.previous7Days && !this.props.listPreviousPostingsArrays.previous9Days
            )
            || (
                this.props.listPreviousPostingsArrays.previous7Days.length <=1  && this.props.listPreviousPostingsArrays.previous9Days.length <= 1
            )
            
        ) {
            return (
                <div style={{ marginTop: 15, marginBottom: 5, marginLeft: 15 }}>
                    {<StrokeIcon icon={'news-paper'} style={{ marginRight: 20 }} />} Not found
                </div>
            )
        } else {
            return (
                <div style={{ marginLeft: 15 }}>
                    {
                        this.props.listPreviousPostingsArrays.previous7Days && this.props.listPreviousPostingsArrays.previous7Days.length > 1 &&
                        (

                            <div style={{ marginTop: 15 }}>
                                <p>Previous 7 days</p>
                                <Timeline >
                                    {this.props.listPreviousPostingsArrays.previous7Days.map((elem, i) => {
                                        // first item is already listed on posted sched list
                                            if (i==0)
                                                return;

                                            const { id } = elem;
                                            const startDate = moment(elem.startDate, 'M/D').format('M/D');
                                            return (
                                                <Timeline.Item
                                                    key={id}
                                                    color={"blue"}
                                                >
                                                    {<a style={{ color: 'dodgerblue ', cursor: "pointer" }} onClick={() => this.props.handleSelectSchedule(elem)} >{startDate}</a>}
                                                </Timeline.Item>
                                            );
                                        
                                    })}
                                </Timeline>
                            </div>
                        )
                    }

                    {
                        this.props.listPreviousPostingsArrays.previous9Days && this.props.listPreviousPostingsArrays.previous9Days.length > 1 &&
                        (
                            <div >
                                <p>Previous 9 days</p>
                                <Timeline >
                                    {this.props.listPreviousPostingsArrays.previous9Days.map((elem, i) => {
                                        // first item is already listed on posted sched list
                                            if (i==0)
                                                return;
                                            const { id } = elem;
                                            const startDate = moment(elem.startDate, 'M/D').format('M/D');
                                            return (
                                                <Timeline.Item
                                                    key={id}
                                                    color={"blue"}
                                                >
                                                    {<a style={{ color: 'dodgerblue ', cursor: "pointer" }} onClick={() => this.props.handleSelectSchedule(elem)}   >{startDate}</a>}
                                                </Timeline.Item>
                                            );
                                        
                                    })}
                                </Timeline>
                            </div>
                        )
                    }

                </div>
            );
        }


    }
}

export default PostedSchedulesList;




// WEBPACK FOOTER //
// ./src/Components/Schedule/PreviousPostingsList.js